import React, { Component } from 'react';
import ContentBox from '../components/FormArea/ContentBox';
import Input from '../components/Inputs/Input';
import Button from '../components/Button';
import settings from '../../settings';
import swal from '@sweetalert/with-react';

class ExportStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from: 0,
      to: 0,
      loading: false,
    };
  }

  exportStatistics = () => {
    // Die required-Validatoren der Felder werden ohne Form/validate() nie
    // ausgefuehrt. Ohne Eingabe wurden die Startwerte (0) gesendet, was
    // serverseitig keinen gueltigen Zeitraum ergibt.
    if (!this.state.from || !this.state.to) {
      swal('Zeitraum fehlt', 'Bitte Von- und Bis-Datum angeben.', 'warning');
      return;
    }

    this.setState({ loading: true });
    const url = `${settings.excel.getExportStatistics}?from=${this.state.from}&to=${this.state.to}`;
    fetch(url, {
      method: 'GET',
    })
      .then((res) => {
        // Fehlerantworten wurden bisher ungeprueft als .xlsx gespeichert; die
        // Datei enthielt dann die HTML-Fehlerseite des Servers.
        if (!res.ok) {
          throw new Error(`Der Server hat mit HTTP ${res.status} geantwortet.`);
        }
        if ((res.headers.get('content-type') || '').includes('text/html')) {
          throw new Error(
            'Der Server hat eine Fehlerseite statt einer Excel-Datei geliefert.',
          );
        }
        return res.blob();
      })
      .then((blob) => {
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.setAttribute('download', 'Statistik.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.setState({ loading: false });
        swal('Erfolgreich', 'Statistik erfolgreich exportiert.', 'success');
      })
      .catch((err) => {
        console.error('Error downloading list:', err);
        this.setState({ loading: false });
        swal(
          'Export fehlgeschlagen',
          `${err.message} Bei langen Zeiträumen kann der Export das Zeitlimit des Servers überschreiten.`,
          'error',
        );
      });
  };

  render() {
    return (
      <div>
        <div className="Headerbar sticky">
          <div className="Headerbar-breadcrumbs">
            <b>Export Statistik</b>
          </div>
        </div>
        <div className="exportStatistic-content-area">
          <ContentBox title="Excel Statistik File Exportieren">
            <Input
              type="date"
              validator={[
                {
                  required: true,
                  error: 'Pflichtfeld ist nicht ausgefüllt.',
                },
              ]}
              onChange={(value) => {
                return this.setState({ from: value });
              }}
              label="Von:"
              name="Chiffre"
            />
            <Input
              type="date"
              validator={[
                {
                  required: true,
                  error: 'Pflichtfeld ist nicht ausgefüllt.',
                },
              ]}
              onChange={(value) => {
                return this.setState({ to: value });
              }}
              label="Bis:"
              name="FirstName"
            />
            <div className="exportStatistic-button-area">
              <Button
                type="primary"
                onClick={() => {
                  return this.exportStatistics();
                }}
              >
                {this.state.loading ? 'Loading...' : 'Exportieren'}
              </Button>
            </div>
          </ContentBox>
        </div>
      </div>
    );
  }
}

export default ExportStatistics;
